/**
 * Test IDs for QA automation.
 */
export const testIds = {
  planningGridCombineOrders: "planning-grid-combine-orders",
  planningGridUncombineOrders: "planning-grid-uncombine-orders",
} as const;
